import {Component, Input, OnInit,
	Output, OnDestroy, EventEmitter}            from '@angular/core';
import {FormBuilder, FormGroup, Validators}     from "@angular/forms";
import {NgbActiveModal}                         from "@ng-bootstrap/ng-bootstrap";

import {HttpErrorResponse}                      from "@angular/common/http";
import {Message}                                from "../../services/message/message";
import {MessageEntry}                           from "../../services/message/message-entry";
import {Query}                                  from "../../services/query/query";
import {User}                                   from "../../services/user/user";
import {UserService}                            from "../../services/user/user.service";

import {isNullOrUndefined}                      from "util";
import {Subscription}                           from "rxjs/Subscription";



@Component({
	selector: 'app-user-editor',
	templateUrl: './user-editor.component.html',
	styleUrls: ['./user-editor.component.css']
})


/**
 * Allows the editing/saving of a single user's data.
 */
export class UserEditorComponent implements OnInit, OnDestroy {

	message: Message;
	tForm: FormGroup;
	userData:User = new User();
	userSubscription: Subscription;

	/**
	 * Instantiate this as a modal with FormBuilder support.
	 *
	 * @param {NgbActiveModal} activeModal  This is a modal.
	 * @param {FormBuilder} fb              Use FormBuilder.
	 * @param {UserService} userService     Handles interaction with User database.
	 */
	constructor(

		public activeModal: NgbActiveModal,
	    private fb: FormBuilder,
		private userService: UserService

	) {}


	/**
	 * Initialize the modal User editing form.
	 * Almost everything on the form is disabled when the
	 * form is loaded so the autofills won't work.  There
	 * is a setTimeout here that turn's them on again a
	 * half-second after the page loads.
	 *
	 */
	ngOnInit() {

		// Set up the message window with an initial message.
		let me:MessageEntry = new MessageEntry();
		me.message = 'Loading...';
		me.level = 1;
		this.message = new Message(me);
		this.message.show();

		// Initialize the data structure for the page.
		this.tForm = this.fb.group({
			id: [this.user.id, [Validators.required, Validators.min(-1)]],
			uname: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(256),]],
			email: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(256),]],
			fname: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(50),]],
			lname: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(100),]],
			password: ['', [Validators.minLength(8), Validators.maxLength(256),]],
			password2: ['', [Validators.minLength(8), Validators.maxLength(256),]],
			phone: ['', [Validators.minLength(1), Validators.maxLength(20),]],
			status: ['A'],
			permissions: [1],
		});

		// This is a HACK! It lets Chrome autofill the form, then resets the data to what it should be.
		setTimeout(()=>{
			this.fillFields(this.user);
			me.message = 'Ready';
			me.level = 1;
			this.message = new Message(me);
			this.message.show();
		}, 1500);

	}


	/**
	 * Clear the subscription to avoid memory leaks.
	 */
	ngOnDestroy() {

		if (this.userSubscription) {
			this.userSubscription.unsubscribe();
		}

	}


	/**
	 * Accepts the User that is being edited.
	 */
	@Input() user:User;

	/**
	 * An EventEmitter to notify the parent component that it should update its list of users.
	 */
	@Output() emitter:EventEmitter<string> = new EventEmitter();


	/**
	 * Don't allow the user to close the window if they have unsaved changes.
	 */
	close():void {

		if (! this.tForm.pristine) {

			if (false === confirm("There are unsaved changes. Click 'Cancel' and save your work or 'OK' to abandon the changes")) {

				return;

			}

		}

		this.activeModal.close('Close method');

	}


	/**
	 * Google, in its infinite wisdom, does not honor the autocomplete="off"
	 * HTML command.  When this routine is called by the setTimeout in
	 * ngOnInit(), it resets all the fields (autocompleted or not), to the
	 * original values from the User object.
	 *
	 * @param {User} user  The User object to fill the data fields with.
	 */
	fillFields(user:User):void {

		if (-1 === user.id) {
			this.tForm.controls['uname'].setValue('');
		} else {
			this.tForm.controls['uname'].setValue(user.uname);
			this.tForm.controls['uname'].disable();
		}
		this.tForm.controls['fname'].setValue(user.fname ? user.fname : '');
		this.tForm.controls['lname'].setValue(user.lname ? user.lname : '');
		this.tForm.controls['email'].setValue(user.email ? user.email : '');
		this.tForm.controls['phone'].setValue(user.phone ? user.phone : '');
		this.tForm.controls['password'].setValue('');
		this.tForm.controls['password2'].setValue('');
		this.tForm.controls['status'].setValue(user.status);
		this.tForm.controls['id'].setValue(user.id);
		this.tForm.controls['permissions'].setValue(user.permissions);
		this.tForm.markAsPristine();

	}


	/**
	 * Save the changes
	 */
	saveChanges():void {

		let action:string = (-1 === this.userData.id) ? 'created' : 'updated';
		let pw:string = this.tForm.controls['password'].value.trim();
		let pw2:string = this.tForm.controls['password2'].value.trim();
		if (pw.trim().length > 0 && pw !== pw2) {
			let me:MessageEntry = new MessageEntry();
			me.message = 'Save failed because password and verification don\'t agree';
			me.level = 4;
			this.message = new Message(me);
			this.message.show();
			return;
		}

		// Save the data and handle the response.
		this.userSubscription = this.userService.save(this.userData).subscribe(

			(response) => {

				this.emitter.emit('refresh');
				this.fillFields(response);
				let me:MessageEntry = new MessageEntry();
				me.message = 'User \'' + this.userData.uname + '\' ' + action;
				me.level = 1;
				this.message = new Message(me);
				this.message.show();

			},
			(e_response) => {

				let me:MessageEntry = new MessageEntry();

				if (e_response instanceof HttpErrorResponse && ! isNullOrUndefined(e_response.error.message)) {

					me.message = 'User \'' + this.userData.uname + '\' failed to update. Message: ' + e_response.error.message;

				} else {

					me.message = 'User \'' + this.userData.uname + '\' failed to update';

				}

				me.level = 4;
				this.message = new Message(me);
				this.message.show();

			}

		)


	}



}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-editor.component.ts